import { render, staticRenderFns } from "./CvExperience.vue?vue&type=template&id=52851996&scoped=true"
import script from "./CvExperience.vue?vue&type=script&lang=js"
export * from "./CvExperience.vue?vue&type=script&lang=js"
import style0 from "./CvExperience.vue?vue&type=style&index=0&id=52851996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52851996",
  null
  
)

export default component.exports